export default "__VITE_ASSET__7ddf66ce__"